import { CountryValidationsData } from "../../server/crm/api/models/countryValidations";
import { PartnerCenterSeller } from "../../server/partnerCenter/models/entities";
import { MiddlewarePartner } from "../../server/partnerCenter/models/middlewarePartner";
import { PartnerCenterScope } from "../scopes";
import { createOnboardingAction, createOnboardingAsyncAction } from "./helpers";

export enum PartnerCenterActions {
  FETCH_COUNTRY_VALIDATION_START = "@countryValidation/FETCH_COUNTRY_VALIDATION_START",
  FETCH_COUNTRY_VALIDATION_COMPLETED = "@countryValidation/FETCH_COUNTRY_VALIDATION_COMPLETED",
  FETCH_COUNTRY_VALIDATION_ERROR = "@countryValidation/FETCH_COUNTRY_VALIDATION_ERROR",
  FETCH_FILE_UPLOAD_START = "@countryValidation/FETCH_FILE_UPLOAD_START",
  FETCH_FILE_UPLOAD_COMPLETED = "@countryValidation/FETCH_FILE_UPLOAD_COMPLETED",
  FETCH_FILE_UPLOAD_ERROR = "@countryValidation/FETCH_FILE_UPLOAD_ERROR",
  UPDATE_SELLERS = "@partnerCenter/UPDATE_SELLERS",
  UPDATE_MIDDLEWARE_PARTNERS = "@partnerCenter/UPDATE_MIDDLEWARE_PARTNERS",
}

export const partnerCenterActions = {
  fetchCountryValidation: createOnboardingAsyncAction(
    PartnerCenterScope,
    PartnerCenterActions.FETCH_COUNTRY_VALIDATION_START,
    (country: string) => ({ country }),
    PartnerCenterActions.FETCH_COUNTRY_VALIDATION_COMPLETED,
    (data: CountryValidationsData, country: string) => ({
      data,
      country,
    }),
    PartnerCenterActions.FETCH_COUNTRY_VALIDATION_ERROR,
    (error: Error) => ({ error })
  ),
  fetchFileUpload: createOnboardingAsyncAction(
    PartnerCenterScope,
    PartnerCenterActions.FETCH_FILE_UPLOAD_START,
    ({ chunk, chunkIndex, totalChunks, fileName, uploadId, dunsValue, typeFile }) => ({
      fileName,
      chunk,
      chunkIndex,
      totalChunks,
      uploadId,
      dunsValue,
      typeFile,
    }),
    PartnerCenterActions.FETCH_FILE_UPLOAD_COMPLETED,
    () => ({}),
    PartnerCenterActions.FETCH_FILE_UPLOAD_ERROR,
    (error: Error) => ({ error })
  ),
  updateSellers: createOnboardingAction(
    PartnerCenterActions.UPDATE_SELLERS,
    PartnerCenterScope,
    (sellers: PartnerCenterSeller[]) => ({
      sellers,
    })
  ),
  updateMiddlewarePartners: createOnboardingAction(
    PartnerCenterActions.UPDATE_MIDDLEWARE_PARTNERS,
    PartnerCenterScope,
    (middlewarePartners: MiddlewarePartner[]) => ({
      middlewarePartners,
    })
  ),
};
